"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _coreFunctionalStepper = _interopRequireDefault(require("@legacy-vfuk/core-functional-stepper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Stepper = function Stepper(_ref) {
  var id = _ref.id,
      inverse = _ref.inverse,
      currentStep = _ref.currentStep,
      steps = _ref.steps,
      hideControls = _ref.hideControls,
      localTheme = _ref.localTheme,
      appearance = _ref.appearance;
  return /*#__PURE__*/_react["default"].createElement(_coreFunctionalStepper["default"], {
    id: id,
    inverse: inverse,
    currentStep: currentStep,
    steps: steps,
    hideControls: hideControls,
    localTheme: localTheme,
    appearance: appearance
  });
};

Stepper.displayName = "Stepper";
var _default = Stepper;
exports["default"] = _default;
//# sourceMappingURL=Stepper.js.map